// Opens cal.com booking links (from code or CMS content) as an on-site popup,
// and pushes `demo_booked` to the GTM dataLayer only after a booking succeeds.
// Runs in browser only.

const CAL_ORIGIN = 'https://app.cal.com';
const CAL_SCRIPT = `${CAL_ORIGIN}/embed/embed.js`;
const CAL_NAMESPACE = 'rsdemo';
const CAL_HOSTS = ['cal.com', 'www.cal.com'];
const CAL_THEME = 'light';
const CAL_LAYOUT = 'month_view';
const CAL_BRAND_COLOR = '#0055BF'; // --rs-cta-blue-color
const CAL_BRAND_COLOR_DARK = '#fafafa'; // Cal.com default for dark theme

let calReady = false;
const trackedBookings = new Set();

// Cal.com's official loader snippet: queues calls until embed.js is loaded.
/* eslint-disable */
function loadCalScript() {
  (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, CAL_SCRIPT, "init");
}
/* eslint-enable */

function onBookingSuccess(e) {
  const data = (e && e.detail && e.detail.data) || {};
  const uid = data.uid || '';
  if (uid && trackedBookings.has(uid)) return;
  if (uid) trackedBookings.add(uid);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'demo_booked',
    'DL - calBookingUid': uid,
    'DL - calEventTitle': data.title || '',
  });
}

function ensureCal() {
  if (calReady) return window.Cal.ns[CAL_NAMESPACE];
  loadCalScript();
  window.Cal('init', CAL_NAMESPACE, { origin: CAL_ORIGIN });
  const cal = window.Cal.ns[CAL_NAMESPACE];
  cal('ui', {
    theme: CAL_THEME,
    cssVarsPerTheme: {
      light: { 'cal-brand': CAL_BRAND_COLOR },
      dark: { 'cal-brand': CAL_BRAND_COLOR_DARK },
    },
    hideEventTypeDetails: false,
    layout: CAL_LAYOUT,
  });
  cal('on', { action: 'bookingSuccessfulV2', callback: onBookingSuccess });
  calReady = true;
  return cal;
}

// Returns { calLink, config } for a cal.com booking URL, else null.
export function parseCalUrl(href) {
  let url;
  try {
    url = new URL(href, window.location.href);
  } catch (err) {
    return null;
  }
  if (!CAL_HOSTS.includes(url.hostname)) return null;
  const calLink = url.pathname.replace(/^\/+|\/+$/g, '');
  if (!calLink) return null;
  const config = { layout: CAL_LAYOUT, theme: CAL_THEME };
  url.searchParams.forEach((value, key) => {
    config[key] = value;
  });
  return { calLink, config };
}

function calLinkFromEvent(event) {
  const anchor = event.target && event.target.closest && event.target.closest('a[href]');
  if (!anchor) return null;
  return parseCalUrl(anchor.getAttribute('href'));
}

function handleClick(event) {
  // Every left click (with or without ctrl/cmd/shift) and middle click opens
  // the popup, so bookings always happen where demo_booked can be tracked.
  if (event.defaultPrevented || (event.button !== 0 && event.button !== 1)) return;
  const parsed = calLinkFromEvent(event);
  if (!parsed) return;
  event.preventDefault();
  ensureCal()('modal', { calLink: parsed.calLink, config: parsed.config });
}

// No "Open link in new tab" (right-click menu) or dragging the link to the
// tab bar: cal.com links must only open in the popup.
function blockNewTab(event) {
  if (calLinkFromEvent(event)) event.preventDefault();
}

export function installCalEmbed() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  document.addEventListener('click', handleClick, true);
  // Middle click fires auxclick, not click.
  document.addEventListener('auxclick', handleClick, true);
  document.addEventListener('contextmenu', blockNewTab, true);
  document.addEventListener('dragstart', blockNewTab, true);
}
